import { sum } from 'lodash';
import { checkArray } from '../../../../Components/helper';
import useSinglePackedUnits from './useSinglePackedUnits';

export default function useMultiSingleSizePackedUnits() {
  const { calcDiffSize, calcDiffLength, limitTofourDecimal, toDec } = useSinglePackedUnits();

  const calculateMultiSingleSizePack = async (data, i) => {
    const cloneSinglePackedUnit = data;
    if (checkArray(cloneSinglePackedUnit?.multiplePackedRows)) {
      if (i !== undefined) {
        cloneSinglePackedUnit.multiplePackedRows[i].totalUnits =
          cloneSinglePackedUnit.multiplePackedRows[i]?.packRatio * cloneSinglePackedUnit.multiplePackedRows[i]?.packsQuantity;
      }
      cloneSinglePackedUnit.totalSize = await calcDiffSize(cloneSinglePackedUnit?.multiplePackedRows);
      cloneSinglePackedUnit.totalLength = await calcDiffLength(cloneSinglePackedUnit?.multiplePackedRows);
      cloneSinglePackedUnit.totalPackRatio = await calcPackRatio(cloneSinglePackedUnit?.multiplePackedRows);
      cloneSinglePackedUnit.totalPacks = await calcTotoalPack(cloneSinglePackedUnit?.multiplePackedRows);
      cloneSinglePackedUnit.totalUnits = getSumValue(cloneSinglePackedUnit.multiplePackedRows);

      cloneSinglePackedUnit.totalPriceBeforeDisc = await calcBeforePrice(cloneSinglePackedUnit?.multiplePackedRows);
      cloneSinglePackedUnit.totalDiscountPerUnit = await calcDiscPrice(cloneSinglePackedUnit?.multiplePackedRows);
      if (cloneSinglePackedUnit?.multiplePackedRows) {
        for (const singular of cloneSinglePackedUnit.multiplePackedRows) {
          const persentageValue = (Number(singular?.beforeDiscPrice) * Number(singular?.discount || 0)) / 100;
          singular.afterDiscPrice = singular?.beforeDiscPrice - persentageValue;
        }
      }
      cloneSinglePackedUnit.totalPriceAfterDisc = await calcAfterPrice(cloneSinglePackedUnit?.multiplePackedRows);
    }
    return cloneSinglePackedUnit;
  };

  const getSumValue = (array) => {
    const totalValue = [];
    array.forEach((element) => {
      totalValue.push(parseFloat(element.totalUnits));
    });
    return sum(totalValue);
  };

  function calcBeforePrice(packedRows) {
    const brforePricesTotals = packedRows.map((row) => {
      const priceBeforeDisc = row.beforeDiscPrice && !isNaN(row.beforeDiscPrice) ? parseFloat(row.beforeDiscPrice) : 0;
      const quantity = row.totalUnits && !isNaN(row.totalUnits) ? parseFloat(row.totalUnits) : 0;

      return toDec(priceBeforeDisc * quantity);
    });
    const beforePrice = brforePricesTotals
      .map((row) => row)
      .reduce((a, b) => {
        return parseFloat(a) + parseFloat(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(beforePrice) ? 0 : limitTofourDecimal(beforePrice);
  }

  function calcDiscPrice(packedRows) {
    let discountCnt = packedRows.filter((row) => row.discount && row.discount !== '' && Number(row.discount) !== 0);
    discountCnt = discountCnt.map((val) => String(val.discount));
    discountCnt = [...new Set(discountCnt)];
    discountCnt = discountCnt?.length || 0;
    return discountCnt;
  }

  async function calcPackRatio(packedRows) {
    const rowQuantity = packedRows
      ?.map((row) => row.packRatio)
      ?.reduce((a, b) => {
        return Number(a) + Number(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(rowQuantity) ? 0 : rowQuantity;
  }

  async function calcTotoalPack(packedRows) {
    const rowQuantity = packedRows
      ?.map((row) => row.packsQuantity)
      ?.reduce((a, b) => {
        return Number(a) + Number(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(rowQuantity) ? 0 : rowQuantity;
  }

  function calcAfterPrice(packedRows) {
    const afterPricesTotals = packedRows.map((row) => {
      const priceAfterDisc = row.afterDiscPrice && !isNaN(row.afterDiscPrice) ? parseFloat(row.afterDiscPrice) : 0;
      const quantity = row.totalUnits && !isNaN(row.totalUnits) ? parseFloat(row.totalUnits) : 0;
      return toDec(priceAfterDisc * quantity);
    });

    const price = afterPricesTotals
      .map((row) => row)
      .reduce((a, b) => {
        return parseFloat(a) + parseFloat(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(price) ? 0 : limitTofourDecimal(price);
  }

  return {
    calculateMultiSingleSizePack,
  };
}
